import React from 'react';
import './FacelessVideoFactory.css';

const AnalyticsWidget = ({ data }) => {
  return (
    <div className="fvf-glass-card" style={{ padding: '20px' }}>
      <p style={{ color: '#8b949e', fontSize: '0.875rem', marginTop: 0, marginBottom: '8px', fontWeight: '500' }}>
        {data.label}
      </p>
      
      <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px' }}>
        <h2 style={{ color: 'white', fontSize: '2.5rem', margin: 0, fontWeight: '800' }}>
          {data.value}
        </h2>
        
        <span style={{ 
          color: data.isPositive ? '#10b981' : '#ef4444',
          fontSize: '0.875rem',
          fontWeight: '600',
          display: 'flex',
          alignItems: 'center',
          gap: '4px'
        }}>
          {data.trend}
        </span>
      </div>
    </div>
  );
};

export default AnalyticsWidget;
